import {http} from './config/config-relation-register'

export default{
    listar:async(token,itens_pagina,pagina,filter,params = {})=>{
        const queryParams = { ...params }

        if (itens_pagina && pagina) {
            queryParams.itens_pagina = itens_pagina
            queryParams.pagina = pagina
        }

        if (filter !== undefined && filter !== null && filter !== '') {
            queryParams.filter = filter
        }

        return http.get('produtos', {
            headers:{
                'Authorization':token
            },
            params: queryParams,
        })
    },
    salvar:(token, produto)=>{
        return http.post('produtos',produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idProduto)=>{
        return http.delete('produtos/'+idProduto,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produto)=>{
        return http.put('produtos/'+produto.id_produto,produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    additionalInformation:(token, id)=>{
        return http.get(`produtos/additional-information/${id}`, {
            headers:{
                'Authorization':token
            }
        })
       
    },
}
